<template>
  <div class="a-vg-b--single-bet"
    :class="extractClassForDogPositionStatus(stake, roundNo)">
    <div class="body">
      <div class="body--top">
        <span>{{$t('vdog_round')}}:</span>
        <span>{{extractRoundNo(stake.roundNo)}}</span>
    </div>
    <div class="body--middle">
      <div class="a-vg-c--on"
          :class="extractClassForDogPosition(extractPosition(stake) - 1)"
          v-if="showDogPosition(stake)">
            <span>{{extractPosition(stake)}}</span>
      </div>
      <div class="body--middle__content">
        <p>
          {{$t(stake.tableName)}}
          <span>/ {{format(stake.Factor/100)}} /</span>
        </p>
        <p>
          {{$t('vdog_bet')}}:
          <span> {{format(stake.bet)}} {{stake.currency}}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="head" @click="onDelete()">
    <image-svg :imageName="'close-app'"/>
  </div>
</div>
</template>

<script>

import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import ImageSVG from '@/components/common/ImageSVG.vue'
import LanguageHelper from '@/mixins/LanguageHelper'
import vuexStore from '../../../store/vuexStore'

import betReset from '../../../assets/audio/bet_reset.mp3'

export default {
  components: {
    'image-svg': ImageSVG
  },
  mixins: [NumberFormat, VDogHelper, LanguageHelper],
  props: {
    stake: {
      type: Object,
      required: true
    },
    roundNo: {
      type: Number,
      required: true
    },
    isBettingEnabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  computed: {
    isButtonResetAndConfirmActive: function () {
      return !this.isBettingEnabled || !this.isAddStakeButtonActive()
    }
  },
  methods: {
    onDelete: function () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(betReset)
        audio.play()
      }
      this.$emit('onDelete')
    },
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    },
    showDogPosition (stake) {
      return stake.StakeTypeEnum < 7
    },
    extractPosition (stake) {
      if (stake.StakeTypeEnum < 7) {
        return stake.StakeEnum
      }
      return ''
    },
    extractRoundNo (roundNo) {
      return roundNo % 1000
    },
    extractClassForDogPositionStatus (stake, roundNo) {
      let status = ''
      let isNotEquals = this.extractRoundNo(stake.roundNo) !== this.extractRoundNo(roundNo)
      if (!isNotEquals && this.isBettingEnabled) {
        status = 'gr-single-bet a-vg-b--single-bet__success'
      } else if (!isNotEquals && !this.isBettingEnabled) {
        status = 'a-vg-b--single-bet__overdue'
      } else {
        status = 'a-vg-b--single-bet__danger'
      }
      return status
    }
  }
}
</script>
